import {WorkDayTimeRangeType} from '../workdays-form-item-type';

export const defaultWorkDayTimeRange: WorkDayTimeRangeType = {
    timeFrom: null,
    timeTo: null,
};
